// extracted by mini-css-extract-plugin
export var buttonSayHi = "sayHi-module--buttonSayHi--2Ts-u";
export var textSayHi = "sayHi-module--textSayHi--2YELF";
export var logoSpin = "sayHi-module--logo-spin--1OgEe";
export var mailSayHi = "sayHi-module--mailSayHi--XkZYa";